<template>
  <div class="edu-courses-area pt-70 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div v-for="course in courses" :key="course.id" class="col-lg-4 col-md-6 col-sm-6 d-flex">
          <div class="single-courses-box">
            <div class="image">
              <router-link :to="{ name: 'CoursesDetailsPage', params: { id: course.id } }" class="d-block">
                <img :src="course.image" :alt="course.title" />
              </router-link>
              <div class="cr-tag">
                <span>{{ course.category }}</span>
              </div>
            </div>
            <div class="content">
              <span class="cr-price">{{ course.price }}₺</span>
              <h3>
                <router-link :to="{ name: 'CoursesDetailsPage', params: { id: course.id } }">
                  {{ course.title }}
                </router-link>
              </h3>
              <ul class="cr-items">
                <li><i class="bx bx-food-menu"></i> <span>{{ course.lessons }} Ders</span></li>
                <li><i class="bx bx-time-five"></i> <span>{{ course.duration }}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import courses from "@/data/courseData";

export default defineComponent({
  name: "CoursesContent",
  data() {
    return { courses };
  },
});
</script>

<style scoped>
.single-courses-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}

.single-courses-box .image img {
  width: 100%;
  height: 220px;
  /* sabit yükseklik */
  object-fit: cover;
}

.single-courses-box .content {
  flex: 1;
  /* içerik stretch olacak */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
}
</style>
